import "./Our_Programs.css";

import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import Explore_Btn from "../../common/explore-btn/Explore_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { Card, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { AllProgramList } from "../../../features/admin/common/Slice";
import { useNavigate } from "react-router-dom";

const Our_Programs = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const allPrograms = useSelector(
    (state) => state.common.all_program_list || [],
  );

  console.log(allPrograms, "allProgramsallProgramsallProgramsallPrograms");
  useEffect(() => {
    setLoading(true);
    dispatch(AllProgramList()).finally(() => setLoading(false));
  }, [dispatch]);

  // const programData = [
  //   {
  //     id: 1,
  //     badge1: "Online Program",
  //     badge2: "NASSCOM Certified",
  //     title: "TRANSFORMER PROGRAM",
  //     subtitle: "For Senior Software Engineers",
  //     duration: "6 Months",
  //     eligibility: "1+ year experience",
  //     highlights: [
  //       "Master DSA, System Design & Full Stack with AI.",
  //       "Live sessions, projects & complete placement support.",
  //       "Get 1:1 mentorship from top engineers.",
  //     ],
  //   },
  //   {
  //     id: 2,
  //     badge1: "Online Program",
  //     badge2: "NASSCOM Certified",
  //     title: "EVOLVE PROGRAM",
  //     subtitle: "For Senior Software Engineers",
  //     duration: "4 Months",
  //     eligibility: "1+ year experience",
  //     highlights: [
  //       "Master DSA, System Design & Full Stack with AI.",
  //       "Live sessions, projects & complete placement support.",
  //       "Get 1:1 mentorship from top engineers.",
  //     ],
  //   },
  //   {
  //     id: 3,
  //     badge1: "Hybrid Program",
  //     badge2: "NASSCOM Certified",
  //     title: "EVOLVE PROGRAM",
  //     subtitle: "For Senior Software Engineers",
  //     duration: "5 Months",
  //     eligibility: "1+ year experience",
  //     highlights: [
  //       "Master DSA, System Design & Full Stack with AI.",
  //       "Live sessions, projects & complete placement support.",
  //       "Get 1:1 mentorship from top engineers.",
  //     ],
  //   },
  //   {
  //     id: 4,
  //     badge1: "Online Program",
  //     badge2: "NASSCOM Certified",
  //     title: "EVOLVE PROGRAM",
  //     subtitle: "For Working Professionals",
  //     duration: "6 Months",
  //     eligibility: "1+ year experience",
  //     highlights: [
  //       "Master DSA, System Design & Full Stack with AI.",
  //       "Live sessions, projects & complete placement support.",
  //       "Get 1:1 mentorship from top engineers.",
  //     ],
  //   },
  // ];
  return (
    <section className="Our_Programs">
      <div className="container">
        <div className="Our_Programs_header">
          <h5>Our Programs</h5>
        </div>

        <div className="program_section">
          {loading ? (
            <div className="text-center my-5">
              <Spinner animation="border" variant="primary" />
              <p>Loading programs...</p>
            </div>
          ) : (
            <Swiper
              modules={[Pagination,Autoplay]}
              // pagination={{ clickable: true }}
              slidesPerView={3}
              spaceBetween={25}
               autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
              loop
              breakpoints={{
                0: { slidesPerView: 1 },
                575: { slidesPerView: 1.5 },
                768: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
              }}
            >
              {allPrograms.length > 0 ? (
                allPrograms.map((program) => (
                  <SwiperSlide key={program.id}>
                    <Card className="program_card">
                      <Card.Body>
                        {/* Badges */}
                        <div className="badge_holder mb-3">
                          <div className="badge_div">
                            <p className="badge_text">Online Program</p>
                          </div>
                          <div className="badge_div">
                            <p className="badge_text">
                              <FontAwesomeIcon
                                icon={faCircleCheck}
                                style={{ color: "#006FCF" }}
                                className="badge_icon"
                              />{" "}
                              NASSCOM Certified
                            </p>
                          </div>
                        </div>

                        {/* Title */}
                        <Card.Title className="program_title">
                          {program.name}
                        </Card.Title>
                        <Card.Subtitle className="program_subtitle mb-4">
                          {program.eligibility}
                        </Card.Subtitle>

                        {/* Duration */}
                        <div className="duration_holder">
                          <div className="duration_div border_div">
                            <p className="course_text">COURSE DURATION</p>
                            <p className="duration">{program.duration}</p>
                          </div>
                          <div className="duration_div">
                            <p className="course_text">ELIGIBILITY</p>
                            <p className="duration">{program.eligibility}</p>
                          </div>
                        </div>

                        
                        {/* Highlights */}
                        <div className="program_highlights">
                          <h6 className="highlight_text">Program highlights</h6>
                            <div className="list_holder">

                          {program?.key_highlights?.length > 0 ? (
                            program.key_highlights.map((item) => (
                              <p className="list_text" key={item.id}>
                                {item.highlight}
                              </p>
                            ))
                          ) : (
                            <p>No highlights available.</p>
                          )}
                            </div>
                        </div>

                        <div className="Explore_Btn_holder">
                          <Explore_Btn
                            onClick={() =>
                              navigate(`/explore-program/${program.id}`)
                            }
                          />
                        </div>
                      </Card.Body>
                    </Card>
                  </SwiperSlide>
                ))
              ) : (
                <p className="text-center">
                  No programs available at the moment.
                </p>
              )}
            </Swiper>
          )}
        </div>
      </div>
    </section>
  );
};

export default Our_Programs;
